import type { GlobalConfigurationDto } from "../../types/GlobalConfigurationDto";
import type { GlobalConfigurationEntity } from "../../types/GlobalConfigurationEntity";

export const GlobalConfigurationEntityToDto = ({
    id: _id,
    dynamicProperties,
    ...rest
}: Readonly<GlobalConfigurationEntity>): GlobalConfigurationDto => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue, idx) => {
        const dynamicPropertyItem = dynamicProperties?.dynamicPropertyValues?.[idx];
        const value = propValue.type === "TEXT" ? dynamicPropertyItem?.value || "" : dynamicPropertyItem?.value;
        const readOnly = dynamicPropertyItem?.readOnly || false;

        return {
            id: propValue.id,
            key: propValue.key,
            label: propValue.label,
            type: propValue.type,
            pattern: propValue.pattern || "",
            value,
            readOnly,
        };
    });

    return {
        ...rest,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
